



<div class="rate-div money-back-block">
    <div class="left-col">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.56808 5.676C12.8054 1.384 20.5454 1.68267 25.4347 6.572C30.6414 11.7787 30.6414 20.2213 25.4347 25.428C20.2281 30.6347 11.7854 30.6347 6.57875 25.428C4.98115 23.8322 3.81533 21.8566 3.19074 19.6866C2.56616 17.5167 2.5033 15.2236 3.00808 13.0227L3.11075 12.6053L5.68941 13.2853C5.05014 15.715 5.289 18.2924 6.36392 20.5632C7.43883 22.834 9.28079 24.6525 11.5652 25.6982C13.8496 26.744 16.4298 26.9498 18.8511 26.2794C21.2724 25.6091 23.3793 24.1056 24.8007 22.0339C26.222 19.9622 26.8664 17.4553 26.6204 14.955C26.3744 12.4547 25.2537 10.1215 23.4559 8.36654C21.6581 6.61159 19.2985 5.54755 16.793 5.36195C14.2875 5.17636 11.7969 5.8811 9.76008 7.352L9.46675 7.57333L10.8227 8.92933L4.69475 10.3427L6.10808 4.21467L7.56808 5.676ZM17.3401 8V10.6667H20.6734V13.3333H13.3401C13.1735 13.333 13.0128 13.3951 12.8897 13.5073C12.7666 13.6196 12.69 13.7739 12.6749 13.9398C12.6599 14.1057 12.7075 14.2712 12.8084 14.4038C12.9093 14.5363 13.0562 14.6263 13.2201 14.656L13.3401 14.6667H18.6734C19.5575 14.6667 20.4053 15.0179 21.0304 15.643C21.6556 16.2681 22.0067 17.1159 22.0067 18C22.0067 18.8841 21.6556 19.7319 21.0304 20.357C20.4053 20.9821 19.5575 21.3333 18.6734 21.3333H17.3401V24H14.6734V21.3333H11.3401V18.6667H18.6734C18.84 18.667 19.0007 18.6049 19.1238 18.4927C19.2469 18.3804 19.3235 18.2262 19.3386 18.0602C19.3536 17.8943 19.306 17.7288 19.2051 17.5962C19.1042 17.4637 18.9573 17.3737 18.7934 17.344L18.6734 17.3333H13.3401C12.456 17.3333 11.6082 16.9821 10.9831 16.357C10.3579 15.7319 10.0067 14.8841 10.0067 14C10.0067 13.1159 10.3579 12.2681 10.9831 11.643C11.6082 11.0179 12.456 10.6667 13.3401 10.6667H14.6734V8H17.3401Z" fill="#4B0082"/>
        </svg>
    </div>
    <div class="right-col text-left">
        <h5 class="text-left">14-DAY MONEYBACK GUARANTEE!</h5>
        <p>
            If you are not satisfied with Bot-Removal scan/cleaning job you can easily request a refund by contacting <span class="support-link"><b>our technical support</b></span>.
        </p>
    </div>
</div>


<style>
    .money-back-block {
        padding: 15px 20px;
        display: flex;
        margin: 0 auto;
        max-width: 850px;
        margin-top: 40px;
        min-height: auto !important;
        height: auto !important;
    }

    .money-back-block .left-col {
        width: 60px;
    }

    .money-back-block h5 {
        font-size: 14px;
        font-weight: 500;
        margin: 0;
    }
    .money-back-block p {
        font-size: 14px;
        font-weight: 100;
        font-family: 'Roboto';
    }

    .money-back-block .support-link {
        font-weight: bold;
        font-size: 14px;
        color: #4B0082;
    }
</style>